import {
  toLaunchParams,
  type LaunchOption,
  type LaunchParams,
} from '@/hooks/useLauncher';

export const AUTHORIZE_URL = '/integration/canva/authorize';

export type GetAuthUrlArg = {
  redirect?: string;
  launch?: LaunchOption;
  launchParams?: LaunchParams;
};

export const getAuthUrl = ({
  redirect,
  launch,
  launchParams,
}: GetAuthUrlArg): string => {
  const redirectUrl = new URL(redirect ?? location.pathname, location.origin);

  if (launch) {
    redirectUrl.searchParams.set('launch', launch);
    if (launchParams) {
      Object.entries(toLaunchParams(launchParams)).forEach(([key, value]) => {
        redirectUrl.searchParams.set(key, value);
      });
    }
  }

  const query = new URLSearchParams({ redirect: redirectUrl.toString() });
  return `${AUTHORIZE_URL}?${query}`;
};
